import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import style from "./styles/textinputfield.scss";

export default class TextInputField extends React.Component {
    render() {
        const {
            id,
            title,
            options,
            emptyValue,
            placeholder,
            error,
            errorText,
            helperText,
            required,
            disabled,
            inputValue,
            onBlur,
            onFocus,
            uiSchema
        } = this.props;

        const { classes = {} } = uiSchema;
        const onChange = ({ target: { value } }) => (
            this.props.onChange(id, value === '' ? emptyValue : value)
        );

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component="fieldset"
                    classes={{
                        root: classes.fieldSet || ''
                    }}
                >
                    <TextField
                        id={ id }
                        label={ title }
                        classes={{
                            root: classes.textField ? `${style.textInputField} ${classes.textField}` : style.textInputField,
                        }}
                        variant={ options.variant ? options.variant : 'outlined' }
                        multiline={ options.multiline ? options.multiline : false }
                        minRows={ options.rows ? options.rows : 1 }
                        onChange={ !disabled ? onChange : null }
                        placeholder={ placeholder }
                        error={ error }
                        required={ required }
                        disabled={ disabled }
                        value={ inputValue || '' }
                        onBlur={ onBlur && (event => onBlur({ id, value: event.target.value })) }
                        onFocus={ onFocus && (event => onFocus({ id, value: event.target.value })) }
                        inputProps={{
                            'data-cy': `${id}-text-field`
                        }}
                        size={ options.size }
                    />
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

TextInputField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    placeholder: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({
        variant: PropTypes.string,
        multiline: PropTypes.bool,
        rows: PropTypes.number,
        size: PropTypes.string
    }),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            textField: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string
        })
    }),
    inputValue: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func
};

TextInputField.defaultProps = {
    title: '',
    emptyValue: '',
    placeholder: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    options: {
        variant: 'outlined',
        multiline: false,
        rows: 1,
        size: 'medium'
    },
    uiSchema: {},
    inputValue: '',
    helperText: ''
};
